import classNames from 'classnames';
import { memo } from 'react';
import { InView } from 'react-intersection-observer';

import { useTranslation } from '@gem/modules/i18n';
import { popupItemStyles } from '@gem/ui-kit';
import { isMentionAll } from '@gem/utils';

import { AvatarTypes } from 'APP/components/Avatar/Avatar';
import { PopupInfoCard } from 'APP/components/PopupInfoCard/PopupInfoCard';

import styles from './styles.m.css';

const Mention = ({
  index,
  mention,
  isFocused,
  onHoverMention,
  onSelectMention,
  onChangeViewState,
}) => {
  const { t } = useTranslation();

  const name = isMentionAll(mention.nickName)
    ? t('common_all_members')
    : mention.displayName || mention.contactName || mention.userName;
  const classes = classNames(popupItemStyles.smallContainer, {
    [popupItemStyles.active]: isFocused,
  });

  return (
    <InView
      as="button"
      className={classes}
      threshold={1}
      onClick={() => onSelectMention(mention)}
      onMouseEnter={() => onHoverMention(index)}
      onChange={(inView) => onChangeViewState(index, inView)}
    >
      <div className={styles.container}>
        <PopupInfoCard
          className={styles.infoCard}
          type={AvatarTypes.Round_0}
          avatarTitle={name}
          avatarUrl={mention.avatarUrl}
          avatarBackgroundColorIndex={mention.id.toString().at(-1)}
          title={name}
          subtitle={`@${mention.nickName}`}
        />
      </div>
    </InView>
  );
};

export default memo(Mention);
